///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export const ACCOUNTANTS_BASE_URL = 'accountants';
export const CUSTOMERS_SUPPORT_BASE_URL = 'customersSupport';
export const SALES_BASE_URL = 'sales';
